import Link from 'next/link';
import { useRouter } from 'next/router';
import { removeDefaultParams } from '../../../Utils/helper';
import {
  clickCardEvent,
  fireClickedCta,
} from '../../../Utils/StoreHomePageUtils';
import { AddToCartButtonFilled } from '../../StoreCategoryPage/SubCategoryProducts/styled';
import BannersGridImage from '../BannersGrid/BannersGridImage';
import { GridBoxTitle } from '../BannersGrid/styled';
import { CardContent, CarouselCardBox } from './styled';

export default function GridCarouselCard(props) {
  const {
    parentIndex,
    banner,
    type,
    element,
    index,
    sectionName,
    length,
    sectionHeading,
  } = props;
  const router = useRouter();

  const onBannerClick = (value, itemName) => {
    let category_id = value?.deeplinkValue.split('_')[1];
    clickCardEvent(value, category_id, type, itemName, {
      heading: banner?.heading || banner?.itemName,
      itemId: banner?.itemId,
    });
  };
  return (
    <CarouselCardBox
      className="column_direction"
      key={index}
      id={
        index == 0
          ? `${sectionName}first`
          : index == length - 1
            ? `${sectionName}last`
            : `testimonial${index}`
      }
    >
      <BannersGridImage
        parentIndex={parentIndex}
        element={element}
        onBannerClick={onBannerClick}
        banner={banner}
        sectionHeading={sectionHeading}
      />
      {element?.heading && <GridBoxTitle>{element.heading}</GridBoxTitle>}
      {element?.subHeading && <CardContent>{element.subHeading}</CardContent>}
      {element?.showCta ? (
        <Link
          href={{
            pathname: element?.deeplinkValue,
            query: removeDefaultParams(router.query),
          }}
          passHref
          locale={false}
          legacyBehavior
        >
          <AddToCartButtonFilled
            listTemplate
            as="a"
            className="add_btn_filled"
            onClick={() => fireClickedCta(element, banner)}
          >
            {element.ctaText}
          </AddToCartButtonFilled>
        </Link>
      ) : null}
    </CarouselCardBox>
  );
}
